export default "__VITE_ASSET__BXcH0690__"